import { render, staticRenderFns } from "./DetailCollectionEvent.vue?vue&type=template&id=17a9f322&"
import script from "./DetailCollectionEvent.vue?vue&type=script&lang=js&"
export * from "./DetailCollectionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports